




import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
import PageFetchHook from '@/components/mixins/PageFetchHook';
import PageLeftHook from '@/components/mixins/PageLeftHook.vue';
import store from '@/store';
import * as CvSectionTextStoreEdit from '@/store/modules/cvSectionTextEdit';
import EditContainer from '@/containers/cv-section-text/edit.vue';

const { mapGetters } = createNamespacedHelpers(
  CvSectionTextStoreEdit.namespace
);

const fetch = async params => {
  const { cv_id, id } = params;
  await store.dispatch(
    CvSectionTextStoreEdit.GetCvSectionText.namespaced({
      params: { cv_id, id },
    })
  );
};

export default Vue.extend({
  components: {
    EditContainer,
  },
  mixins: [PageLeftHook, PageFetchHook(fetch)],
  data() {
    return {
      storeList: [CvSectionTextStoreEdit],
    };
  },
  computed: {
    ...mapGetters(['cvSectionText']),
  },
});
